import React, { Component } from 'react';
export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch() {
        //error, errorInfo
        const { setHasError } = this.props;
        setHasError(true);
    }

    componentDidUpdate(prevProps) {
        const { hasError } = this.props;
        if (!hasError && prevProps.hasError) {
            this.setState({ hasError: false });
        }
    }

    render() {
        const { children } = this.props;
        const { hasError } = this.state;

        if (hasError) {
            return (
                <div className="sog-wrapper error-boundary">
                    <div className="sog-container">
                        <p>We apologies for this error. Please retry later.</p>
                        <p>
                            Alternately , you may reach out to us via Whatsapp
                        </p>
                    </div>
                </div>
            );
        }

        return children;
    }
}
